window._ = require('lodash');


// raven-js, the Sentry handler
import Raven from 'raven-js';
if (hostvars['sentry_pdsn'] !== null) {
    Raven
        .config(hostvars['sentry_pdsn'])
        .install();
}

window.$ = window.jQuery = require('jquery');

require('bootstrap-sass');

window.Chartist = require('chartist');
require('chartist-plugin-legend');
require('select2');

// preview page libraries (candidate for breakout?)
require('./bootstrap_preview');


// WEBPACK FOOTER //
// ./resources/assets/js/bootstrap.js